// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c4fb914e","236":"59f1ecce","703":"63244dc2"}[chunkId] + ".chunk.js";
};